import { header2, text2 } from '@ardoq/typography';
import { styled } from 'styled-components';
import { colors } from '@ardoq/design-tokens';
import { Box, FlexBox, Stack } from '@ardoq/layout';

type FullHeightSidebarProps = {
  title?: string;
  subtitle?: string;
  rightContent?: React.ReactNode;
  footerContent?: React.ReactNode;
  children: React.ReactNode;
  titleId?: string; // for accessibility purposes
};

// TODO AM move this to a package to Design System
export const FullHeightSidebar = ({
  title,
  rightContent,
  subtitle,
  children,
  footerContent,
  titleId,
}: FullHeightSidebarProps) => {
  const hasHeader =
    Boolean(title) || Boolean(subtitle) || Boolean(rightContent);
  return (
    <FullHeight>
      {hasHeader && (
        <Box padding="large" paddingBottom="medium">
          <Stack gap="small">
            {(title || rightContent) && (
              <FlexBox align="baseline" justify="space-between" gap="small">
                {title ? <Title id={titleId}>{title}</Title> : <div />}
                {rightContent}
              </FlexBox>
            )}
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
          </Stack>
        </Box>
      )}

      <Box paddingX="medium" paddingTop={hasHeader ? 'none' : 'large'}>
        {children}
      </Box>

      <FooterContentWrapper>{footerContent}</FooterContentWrapper>
    </FullHeight>
  );
};

const FullHeight = styled.aside`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Title = styled.h2`
  ${header2};
  color: ${colors.grey950};
`;

const Subtitle = styled.span`
  ${text2};
  color: ${colors.grey700};
`;

const FooterContentWrapper = styled.div`
  margin-top: auto; /* puts the footer at the bottom of the sidebar */
`;
